<template>
  <div>
    <p class="panel__title">{{ $t('feedback_panel.rating_step_title') }}</p>
    <div class="panel__emojis">
      <template v-for="(rating, index) in ratings">
        <a :key="index" href="#" @click.prevent="$emit('selectRating', rating)">
          <img
            :key="index"
            :src="getEmojiImagePath(rating.imageName)"
            class="panel__emojis-item"
            :class="{
              last: index === ratings.length - 1,
              selected: selectedRating && rating.value === selectedRating.value
            }"
            alt />
        </a>
      </template>
    </div>
    <Feedback v-if="selectedRating" :selected-rating-value="selectedRatingValue" @sendFeedback="sendFeedback" />
  </div>
</template>

<script>
import Feedback from './Feedback'

// Utils
import { getEmojiImagePath } from '@/lib/utils'

export default {
  name: 'Rating',
  components: { Feedback },
  props: {
    ratings: { type: Array, required: true },
    selectedRating: { type: Object, default: null }
  },
  computed: {
    selectedRatingValue() {
      return (this.selectedRating && this.selectedRating.value) || null
    }
  },
  methods: {
    getEmojiImagePath,
    sendFeedback(feedback) {
      this.$emit('sendFeedback', feedback)
    }
  }
}
</script>

<style>
.panel__title {
  padding: 10px;
}
.panel__emojis {
  margin: 0 15px 8px;
}
.panel__emojis-item {
  margin-right: 20px;
  width: 30px;
  height: auto;
  transition: 0.3s ease;
}

[dir='rtl'] .panel__emojis-item {
  margin-right: 0;
  margin-left: 20px;
}
.panel__emojis-item:not(.selected):hover,
.panel__emojis-item.selected {
  -webkit-transform: scale(1.4);
  -moz-transform: scale(1.4);
  -o-transform: scale(1.4);
  transform: scale(1.4);
}
.panel__emojis-item.last {
  margin-right: 0;
}
</style>
